import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { UnsplashImage } from "./unsplash";
import { pexelsImageToUnsplashImageFormat } from "./image-bridge";
import { fetchWithJWT } from "@/futurelayer/auth/jwt";

export interface PexelsImage {
  id: number;
  width: number;
  height: number;
  url: string;
  photographer: string;
  photographer_url: string;
  photographer_id: number;
  avg_color: string;
  src: {
    original: string;
    large2x: string;
    large: string;
    medium: string;
    small: string;
    portrait: string;
    landscape: string;
    tiny: string;
  };
  alt: string;
}

export interface PexelsSearchResponse {
  page: number;
  per_page: number;
  photos: PexelsImage[];
  total_results: number;
  next_page: string | null;
  prev_page: string | null;
}

export interface PexelsRequest {
  query: string;
  page: number;
  per_page: number;
}

export async function callPexels(
  request: PexelsRequest,
  abortController: AbortController
): Promise<UnsplashImage[]> {
  try {
    const response = await fetchWithJWT("/stock-photos/pexels", {
      body: jsonStringifyOrUndefined(request),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result: PexelsSearchResponse = await response.json();
    return result.photos.map(pexelsImageToUnsplashImageFormat);
  } catch (error) {
    console.error("Pexels request failed:", error);
    throw error;
  }
}
